import { createContext, useContext, useState, ReactNode } from "react";
import Snackbar from "@mui/material/Snackbar";

type SnackbarContextType = {
    showSnackbar: (message: string, severity?: "success" | "error" | "info" | "warning", duration?: number) => void;
    hideSnackbar: () => void;
};

const SnackbarContext = createContext<SnackbarContextType | null>(null);

export const useSnackbar = () => useContext(SnackbarContext)!;

export function SnackbarProvider({ children }: { children: ReactNode }) {
    const [snackbar, setSnackbar] = useState<{
        open: boolean;
        message: string;
        severity: "success" | "error" | "info" | "warning";
        duration: number;
    }>({
        open: false,
        message: "",
        severity: "info",
        duration: 3000,
    });

    const showSnackbar = (message: string, severity: "success" | "error" | "info" | "warning" = "info", duration: number = 3000) => {
        setSnackbar({ open: true, message, severity, duration });
    };

    const hideSnackbar = () => {
        setSnackbar((s) => ({ ...s, open: false }));
    }

    return (
        <SnackbarContext.Provider value={{ showSnackbar, hideSnackbar }}>
            {children}
            <Snackbar
                open={snackbar.open}
                message={snackbar.message}
                autoHideDuration={snackbar.duration}
                onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                sx={{backgroundColor: "black", color: "white"}}
            />
        </SnackbarContext.Provider>
    );
}
